import type { PersonRow } from '../../../utils/panorama/panoramaPeopleRows';
import { STATUS_META } from '../vacationOverviewPage.definitions';
import { VacationAvatar } from '../../../components/VacationDpTable/components/VacationAvatar';
import { DateDisplayCell } from './vacationTableCells';

interface VacationOverviewCardProps {
	row: PersonRow;
}

export function VacationOverviewCard({ row }: VacationOverviewCardProps) {
	const meta = STATUS_META[row.status];

	return (
		<article className="rounded-xl border border-raro-gray-200 bg-white p-3 shadow-sm">
			<div className="mb-3 flex items-center justify-between gap-3">
				<div className="flex min-w-0 items-center gap-2">
					<VacationAvatar name={row.name} />
					<div className="min-w-0">
						<p className="truncate text-sm font-semibold text-raro-gray-900">{row.name}</p>
						{row.positionName && (
							<p className="truncate text-xs text-raro-gray-500">{row.positionName}</p>
						)}
					</div>
				</div>
				<div className={`inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-semibold ${meta.badge}`}>
					<span className="h-2 w-2 rounded-full" style={{ backgroundColor: meta.color }} />
					<span className="hidden sm:inline">{meta.label}</span>
				</div>
			</div>

			{row.clientNames && row.clientNames.length > 0 && (
				<div className="mb-3 flex flex-wrap gap-1">
					{row.clientNames.map(client => (
						<span key={client} className="inline-block rounded-full bg-raro-gray-100 px-2 py-0.5 text-xs text-raro-gray-700">
							{client}
						</span>
					))}
				</div>
			)}

			{(row.displayDates?.length ?? 0) > 0 && (
				<div className="space-y-2 text-sm">
					<DateDisplayCell displayDates={row.displayDates || []} status={row.status} expiredDays={row.expiredDays} />
				</div>
			)}
		</article>
	);
}
